/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface HeoCustomerOrderNumber
 */
export interface HeoCustomerOrderNumber {
    /**
     * 
     * @type {string}
     * @memberof HeoCustomerOrderNumber
     */
    companyCode: string;
    /**
     * 
     * @type {number}
     * @memberof HeoCustomerOrderNumber
     */
    retailerNumber: number;
    /**
     * 
     * @type {number}
     * @memberof HeoCustomerOrderNumber
     */
    number: number;
}

/**
 * Check if a given object implements the HeoCustomerOrderNumber interface.
 */
export function instanceOfHeoCustomerOrderNumber(value: object): value is HeoCustomerOrderNumber {
    if (!('companyCode' in value) || value['companyCode'] === undefined) return false;
    if (!('retailerNumber' in value) || value['retailerNumber'] === undefined) return false;
    if (!('number' in value) || value['number'] === undefined) return false;
    return true;
}

export function HeoCustomerOrderNumberFromJSON(json: any): HeoCustomerOrderNumber {
    return HeoCustomerOrderNumberFromJSONTyped(json, false);
}

export function HeoCustomerOrderNumberFromJSONTyped(json: any, ignoreDiscriminator: boolean): HeoCustomerOrderNumber {
    if (json == null) {
        return json;
    }
    return {
        
        'companyCode': json['companyCode'],
        'retailerNumber': json['retailerNumber'],
        'number': json['number'],
    };
}

export function HeoCustomerOrderNumberToJSON(json: any): HeoCustomerOrderNumber {
    return HeoCustomerOrderNumberToJSONTyped(json, false);
}

export function HeoCustomerOrderNumberToJSONTyped(value?: HeoCustomerOrderNumber | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'companyCode': value['companyCode'],
        'retailerNumber': value['retailerNumber'],
        'number': value['number'],
    };
}

